import React from 'react'
import { picProcess } from 'meinian-package/src/utils/image'
import CollectGroupBtn from '../../../component/collectGroupBtn'
import styles from './index.module.less'
import './card.less'

export default ({ columnWidth, mainUrl, itemData, onClickCard, onCollect, height, width, index }) => {
  // 款式卡片
  return (
    <div
      style={{ width: columnWidth, height: Math.round((columnWidth * height) / width) }}
      className={styles['intellect-card-style']}
    >
      <div
        className="intellect-card-content"
        onClick={(e) => {
          onClickCard?.(itemData, e)
        }}
      >
        <div className="intellect-card-hover">
          <div className="hover-collect">
            <CollectGroupBtn currentBlog={itemData} onCollectClick={onCollect} />
            {index === 0 && (
              <div className="mn-collect-behavior-tip">
                <img
                  style={{ width: '32px', height: '32px' }}
                  src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/hand.png"
                />
              </div>
            )}
          </div>
        </div>
        <img
          loading="lazy"
          src={picProcess(mainUrl)}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))',
          }}
        />
        <div className="bottom-bg">
          <span className="user-name">{itemData.userName}</span>
        </div>
      </div>
    </div>
  )
}
